import React from "react";
import PropTypes from "prop-types";
import { Typography, Box, ButtonBase } from "@material-ui/core";
import { COLORS, SPACING } from "../constants";
import { SectionHeading } from "./UI";
import { useStyles } from "../views/wizard-view.style";

export function WizardTemplateStep({ templates, wizardTemplateId, setWizardTemplateId, openNewTemplate }) {
  const classes = useStyles();
  return (
    <Box>
      <SectionHeading>Choose a Template</SectionHeading>
      {templates.map((template) => {
        const isSelected = wizardTemplateId === template.id;
        return (
          <Box
            component="button"
            type="button"
            key={template.id}
            onClick={() => setWizardTemplateId(template.id)}
            className={classes.templateOption}
            sx={{
              background: isSelected ? COLORS.primaryLight : COLORS.white,
              border: `2px solid ${isSelected ? COLORS.primary : COLORS.border}`,
            }}
          >
            <Box
              className={classes.radioCircle}
              sx={{ border: `2px solid ${isSelected ? COLORS.primary : COLORS.border}` }}
            >
              {isSelected && <Box className={classes.radioFill} />}
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: COLORS.body, marginBottom: '4px' }}>
                {template.name}
              </Typography>
              <Typography variant="caption" sx={{ color: COLORS.muted, marginBottom: `${SPACING.detailGap}px`, display: 'block' }}>
                {template.desc}
              </Typography>
              <Box sx={{ display: "flex", gap: `${SPACING.detailGap}px` }}>
                <Typography variant="caption" sx={{ color: COLORS.primary }}>{template.services.length} service{template.services.length === 1 ? "" : "s"}</Typography>
                <Typography variant="caption" sx={{ color: COLORS.primary }}>{template.resources.length} resource{template.resources.length === 1 ? "" : "s"}</Typography>
              </Box>
            </Box>
          </Box>
        );
      })}
      <ButtonBase onClick={openNewTemplate} className={classes.createTemplateButton}>
        <Typography variant="body2" sx={{ color: COLORS.primary, fontWeight: 600 }}>
          + Create New Template
        </Typography>
      </ButtonBase>
    </Box>
  );
}

WizardTemplateStep.propTypes = {
  templates: PropTypes.array,
  wizardTemplateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setWizardTemplateId: PropTypes.func.isRequired,
  openNewTemplate: PropTypes.func.isRequired,
};

WizardTemplateStep.defaultProps = {
  templates: [],
  wizardTemplateId: null,
};
